import React, {useState,useRef} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { ArticleBarSearch } from "@gull"
import axios from 'axios'
import swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const useSearchItem = (props) => {
    const t =useTranslate()
    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')
    const [itemId,setItemId]=useState((props.articleId) ? props.articleId : '')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        setItemId('')
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            ajour = ajour.filter((value)=>value.id!=props.itemId) // filtre pour ne pas retourner l'article parent dans la liste des articles sélectionables
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }

    return [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput,itemId,setItemId]
}

const ItemTransformConfig = (props) =>{
    const t = useTranslate();

    const [loadingSearchItem,setLoadingSearchItem,loadItems,listSearchItem,datas,setDatas,searchInput,itemId,setItemId]=useSearchItem(props)

    const [relanceFocus,setRelanceFocus]=useState(Date.now())

    const [itemValue,setItemValue]=useState((props.articleName) ? props.articleName : '')
    const [disabled,setDisabled]=useState(false)
    const [quantity,setQuantity]=useState((props.quantity) ? props.quantity : 1)

    const addNewItem = async (e,articleid,inputname,articleBar) =>{
        let article = (e) ? e.target.value : articleid
        let urlArticle = (e) ? "api/erp/article/reference/" : "api/erp/article/one/"

        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+urlArticle+article
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                swal.fire(t('articleNoReferenceFind'), "", "error");
            }else{   
                let tempArticleId = ''
                let tempArticleName = ''
                if(e){
                    tempArticleId=response.data.data.article.id
                    tempArticleName=response.data.data.article.name
                    
                }else{
                    tempArticleId=response.data.data.id
                    tempArticleName=response.data.data.name
                } 
                setItemValue(tempArticleName)
                setItemId(tempArticleId)

                props.setDatasForm(prev => 
                    prev.map(line => 
                        line._key == props.index ? { ...line, id: tempArticleId, name: tempArticleName } : line
                    )
                )
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setLoadingSearchItem(false)
    }

    const handleChange = (e) => {
        setQuantity(e.target.value)
        props.setDatasForm(prev => 
            prev.map(line => 
                line._key == props.index ? { ...line, quantity:e.target.value} : line
            )
        )
    }

    return (
        <>
            <div className='row'>
                <div className='col-6'>
                    <ArticleBarSearch 
                        loadingSearchItem={loadingSearchItem}
                        loadItems={loadItems}
                        listSearchItem={listSearchItem}
                        datas={datas}
                        setDatas={setDatas}
                        valueInput={itemValue}
                        setValueInput={setItemValue}
                        handleSubmit={addNewItem}
                        searchInput={searchInput}
                        setRelanceFocus={setRelanceFocus}
                        setItemId={setItemId}
                        noBlur={true}
                        disabled={disabled}
                        setDisabled={setDisabled}
                        noBtnErase={true}
                    />
                </div>
                <div className='col-4'>
                    <input
                        value={quantity}
                        type="number"
                        className='form-control'
                        onChange={(e)=>handleChange(e)}
                    />
                </div>
                <div className='col-2'><FontAwesomeIcon icon={faTrash} className='text-danger pointer' onClick={()=>props.handleRemoveLine()}/></div>
            </div>
        </>
    )
};

export default ItemTransformConfig;